<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="viewDetailsVehicle"
      iconName="mdi-eye"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="View Details"
      @click="viewDetails()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>

<style>
</style>